import SmoothScroll from 'smooth-scroll'
import { menuSwitcher } from '../../../components/header/header.component'
export function appInitScroll() {
  const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 500,
    speedAsDuration: true,
    header: '.header'
  })
  document.addEventListener(
    'scrollStart',
    () => {
      menuSwitcher.state = false
      menuSwitcher.call()
    },
    false
  )
  if (window.location.hash) {
    window.addEventListener('load', () => {
      if (document.querySelector(window.location.hash)) {
        scroll.animateScroll(document.querySelector(window.location.hash))
      }
    })
  }
}
